// below function tend to mimic the behavior of the bootstrap collapse
// which was removed because of security issues
// https://gongio.atlassian.net/browse/SECTKT-8468
function initCollapsibleElements() {
  document
    .querySelectorAll('[data-toggle="collapse"]')
    .forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        // Toggle the target elements
        var targets = button.getAttribute("data-target").split(",");

        targets.forEach(function (target) {
          var element = document.querySelector(target);
          if (element.classList.contains("show")) {
            element.classList.remove("show");
          } else {
            element.classList.add("show");
          }
        });
        return false;
      });
    });
}

function initModalElements() {
  function showModal(modal) {
    modal.classList.add("show");
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
  }

  function hideModal(modal) {
    modal.classList.remove("show");
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  document
    .querySelectorAll('[data-toggle="modal"]')
    .forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var targetSelector = trigger.getAttribute("data-target");
        var modal = document.querySelector(targetSelector);
        if (modal) {
          showModal(modal);
        }
      });
    });

  // Add event listeners to modal close buttons
  document.querySelectorAll(".modal .close").forEach(function (closeButton) {
    closeButton.addEventListener("click", function () {
      var modal = closeButton.closest(".modal");
      if (modal) {
        hideModal(modal);
      }
    });
  });

  // Add event listener to close modal when clicking outside of it
  document.querySelectorAll(".modal").forEach(function (modal) {
    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        hideModal(modal);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function (event) {
  initCollapsibleElements();
  initModalElements();
});

module.exports = initCollapsibleElements;
